import { AlignmentType, BorderStyle, Paragraph } from 'docx';

// Utils
import {
  parseRichText,
  type ParsedParagraph,
} from '@/components/template/resume/utils/richTextParser';
import { DEFAULT_RUN_CONFIG, contentSectionTitle } from '../../utils';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Constants
import { COLORS, LINE_SPACING, SPACINGS } from '../../constants';

/** Creates the bio content section from an HTML bio string */
export const BioSection = (bio: string): Paragraph[] => {
  if (!bio) return [];

  return [
    contentSectionTitle(SECTION_TITLES.bio),
    ...parseRichText(bio, DEFAULT_RUN_CONFIG).map(
      ({ runs, isBlockquote }: ParsedParagraph) =>
        new Paragraph({
          spacing: { line: LINE_SPACING },
          alignment: AlignmentType.JUSTIFIED,
          // Blockquote style with grey left border and indent
          ...(isBlockquote && {
            border: {
              left: {
                style: BorderStyle.SINGLE,
                size: 20,
                color: COLORS.blockquoteBorder,
                space: 8,
              },
            },
            indent: { left: SPACINGS.blockquoteIndent },
          }),
          children: runs,
        }),
    ),
    new Paragraph({ spacing: { after: SPACINGS.sectionBottom } }),
  ];
};
